<template>
    <b-container class="Practices">
      <b-row class="fac">
        <b-col class="practicesImg" sm="12" md="12" lg="6">
          <img class="PracticesBackground" src="@/assets/imagesHome/betterPracticesBG.png" alt="good practices background">
          <img class="practicesImage" id="animPractices" src="@/assets/imagesHome/betterPractices.png" alt="good practices">
        </b-col>
        <b-col sm="12" md="12" lg="6" class="PracticesFlex">
          <h3 v-html="$t('PracticesMsg')"></h3>
          <h3 v-html="$t('PracticesMsg2')"></h3>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
export default {
    name: 'Practices',
    mounted() {
        const scene2 = this.$scrollmagic.scene({
          triggerElement: '#triggerPractices',
          duration: 400
        })
        .setTween( "#animPractices", 0.5, {width:'80%', opacity:1})
        this.$scrollmagic.addScene(scene2)
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/style/practices.scss';
</style>